import { map } from "nanostores";

export type DateRangeFilter = {
  min: Date | undefined;
  max: Date | undefined;
};

type FiltersMap = {
  soldOn: DateRangeFilter;
};

export const $filters = map<FiltersMap>({
  soldOn: { min: undefined, max: undefined },
});

export function setSoldOnMin(value: Date | undefined) {
  const filters = $filters.get();
  $filters.set({ ...filters, soldOn: { ...filters.soldOn, min: value } });
}

export function setSoldOnMax(value: Date | undefined) {
  const filters = $filters.get();
  $filters.set({ ...filters, soldOn: { ...filters.soldOn, max: value } });
}
